import React from 'react';
import ShoppingCartTable from '../shopping-cart-table';

const CartPage = () => {
  return (
    <div className="home-page-wrapper">
      <ShoppingCartTable />
    </div>
    
  )
}

export default CartPage